export default "__VITE_ASSET__CWtIOybs__"